import { TRIGGER_OVERLAY } from './types';

const initialState = {
  opened: false,
  overlayType: ''
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TRIGGER_OVERLAY:
      return {
        ...state,
        opened: action.payload.opened,
        overlayType: action.payload.overlayType
      };
    default:
      return state;
  }
};

export { reducer as overlayReducer };



// WEBPACK FOOTER //
// ./src/store/Overlay/reducer.js